import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    ImageList,
    ImageListItem,
    Typography
} from '@mui/material';

export const FileDialog = ({ open, handleClose, handleSubmit, title, content, imageUrls, confirmText, cancelText, handleOnFileDrop, ...props }) => {

    const [selectedImageUrl, setSelectedImageUrl] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const onDrop = useCallback(async acceptedFiles => {
        if (isUploading) {
            return;
        }

        setIsUploading(true);
        if (handleOnFileDrop) {
            await handleOnFileDrop(acceptedFiles[0])
        }

        setIsUploading(false);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    return (
        <>
            <Dialog
                fullWidth
                open={open}
                handleClose={handleClose}>
                <DialogTitle>{title ?? "File"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <div
                            style={isDragActive && !isUploading ? {
                                border: "1px",
                                padding: "16px",
                                outline: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexWrap: "wrap",
                                cursor: "pointer",
                                color: "white",
                                borderRadius: 2,
                                backgroundColor: "#032b53",
                                opacity: 0.7,
                            } : {
                                border: "1px",
                                padding: "16px",
                                outline: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                flexWrap: "wrap",
                                borderRadius: 2,
                                color: "white",
                                backgroundColor: "rgb(0, 62, 125)",
                                opacity: 1,
                            }}
                            {...getRootProps()}>
                            <input {...getInputProps()} />
                            {isUploading ? <CircularProgress /> : (content ?? "Carica un file")}
                        </div>
                    </DialogContentText>
                    <ImageList cols={3} style={{ height: "30vh", border: "2px", borderStyle: "solid", borderColor: "#06C", padding: 4 }}>
                        {
                            imageUrls?.map(imageUrl =>
                                <ImageListItem
                                    key={imageUrl}
                                    style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Button
                                        onClick={() => setSelectedImageUrl(imageUrl)}
                                        style={{ backgroundColor: selectedImageUrl && selectedImageUrl == imageUrl ? "#e1e1e1" : "" }}>
                                        <img
                                            width="100%"
                                            src={`${imageUrl}`}
                                            loading="lazy" />
                                    </Button>
                                </ImageListItem>
                            )
                        }
                    </ImageList>
                    {
                        selectedImageUrl ?
                            <img
                                width="50%"
                                src={`${selectedImageUrl}`}
                                style={{ marginLeft: "25%", maxHeight: "20vh" }}>
                            </img>
                            :
                            <Typography
                                align="center">
                                SELEZIONA UN'IMMAGINE
                            </Typography>
                    }
                </DialogContent>
                <DialogActions style={{ marginRight: 16, marginBottom: 8 }}>
                    <Button
                        variant="contained"
                        disableElevation
                        onClick={() => {
                            handleClose();
                            setSelectedImageUrl(null);
                        }}>
                        {cancelText ?? "annulla"}
                    </Button>
                    <Button
                        variant="contained"
                        disableElevation
                        onClick={() => {
                            handleSubmit(selectedImageUrl);
                            setSelectedImageUrl(null);
                        }}
                        disabled={!selectedImageUrl}>
                        {confirmText ?? "conferma"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}